@use "./tokens";

.backButton {
  align-items: center;
  text-align: left;
  border: none;
  cursor: pointer;
  display: inline-flex;
  line-height: 1;
  margin-left: calc(#{tokens.$page-gutter} - var(--mobile-gutter));
  padding-left: 0;
  padding-right: 0;
}

.backButtonIcon {
  margin-right: 12px;
}
